import { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const PriceDrop = forwardRef<SVGElement, OwnProps>(props => {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.7228 11.1304L28.1619 9.56942C27.9494 9.35691 27.6917 9.19502 27.408 9.09579L16.131 5.15114C15.4059 4.89751 14.5996 5.08158 14.0564 5.62476L5.20076 14.4804C4.66151 15.0196 4.47586 15.8186 4.7221 16.5404L8.59707 27.8986C8.69579 28.188 8.85954 28.4509 9.07574 28.667L30.4505 50.0418C31.2316 50.8229 32.4979 50.8229 33.2789 50.0418L49.5424 33.7784C50.3234 32.9973 50.3234 31.731 49.5424 30.9499L46.9309 28.3384"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="17"
        cy="17.5005"
        r="4"
        fill="white"
        stroke="#00619E"
        strokeWidth="2"
      />
      <path
        d="M50 20.0504L38.5002 31.5005L27 20.0504H33.2042V8.50049H43.5944V20.0504H50Z"
        stroke="#00AED9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default PriceDrop;
